import {
  Box,
  Flex,
  Heading,
  Text,
  Button,
  HStack,
  Divider,
  Spinner,
  Badge,
  useToast,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTrashList, useRestoreContent } from '../hooks/useCustomContent';

export function TrashPage() {
  const { t } = useTranslation();
  const toast = useToast();
  const { data, isLoading } = useTrashList();
  const restore = useRestoreContent();
  const items = data?.items ?? [];

  return (
    <Box>
      <Button
        as={RouterLink}
        to="/library/clips"
        variant="link"
        color="gray.500"
        leftIcon={<ArrowBackIcon />}
        mb={4}
      >
        {t('customContent.backToClips')}
      </Button>

      <Heading size="lg" color="gray.800" mb={1}>
        {t('customContent.trashTitle')}
      </Heading>
      <Text color="gray.500" mb={4}>
        {t('customContent.trashNote')}
      </Text>
      <Divider mb={2} />

      {isLoading ? (
        <Flex justify="center" py={10}>
          <Spinner color="brand.500" />
        </Flex>
      ) : items.length === 0 ? (
        <Text color="gray.400" py={12} textAlign="center">
          {t('customContent.trashEmpty')}
        </Text>
      ) : (
        items.map((item) => (
          <HStack key={item.id} py={3} px={2} spacing={4} borderBottomWidth="1px" borderColor="gray.100">
            <Box flex={1} minW={0}>
              <Text fontWeight="500" color="gray.800" noOfLines={1}>
                {item.title}
              </Text>
              <Badge colorScheme={item.retentionDaysRemaining <= 3 ? 'red' : 'gray'} mt={1}>
                {t('customContent.retention', { days: item.retentionDaysRemaining })}
              </Badge>
            </Box>
            <Button
              size="sm"
              variant="outline"
              onClick={() =>
                restore.mutate(item.id, {
                  onSuccess: () =>
                    toast({ status: 'success', title: t('customContent.restored'), duration: 2000 }),
                  onError: () => toast({ status: 'error', title: t('common.error', 'Something went wrong') }),
                })
              }
              isLoading={restore.isPending && restore.variables === item.id}
            >
              {t('customContent.restore')}
            </Button>
          </HStack>
        ))
      )}
    </Box>
  );
}

export default TrashPage;
